import React from 'react';
import BottomSheetModal from './BottomSheetModal';
import './AnalysisEditModal.css';

/**
 * Analysis Edit Modal Component
 * Allows editing of the analysis prompt
 */
const AnalysisEditModal = ({ 
  isOpen, 
  onClose, 
  analysisPrompt = '',
  onSave,
  isLoading = false
}) => {
  const [prompt, setPrompt] = React.useState(analysisPrompt);
  
  // Update local state when prop changes
  React.useEffect(() => {
    setPrompt(analysisPrompt);
  }, [analysisPrompt]);
  
  const handleSave = () => {
    onSave(prompt);
    onClose();
  };
  
  const handleCancel = () => {
    setPrompt(analysisPrompt); // Reset to original value
    onClose();
  };
  
  return (
    <BottomSheetModal
      isOpen={isOpen}
      onClose={handleCancel}
      title="Edit Analysis Prompt"
      maxHeight="60vh"
    >
      <div className="analysis-edit-modal-content">
        <div className="form-group">
          <label className="form-label">Analysis Prompt</label>
          <textarea
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            className="form-textarea"
            placeholder="Enter the prompt for analyzing text..."
            rows={6}
            disabled={isLoading}
          />
        </div>
        
        <div className="modal-actions">
          <button 
            onClick={handleCancel} 
            className="btn-secondary"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            className="btn-primary"
            disabled={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </BottomSheetModal>
  );
};

export default AnalysisEditModal; 